import { createRoot } from "react-dom/client"
import App from "./app/App"
import { BrowserRouter } from "react-router-dom"
import { loadStyles } from "./styles/loadStyles"

async function bootstrap() {
    await loadStyles()
    const container = document.getElementById("root")
    const root = createRoot(container!)
    root.render(
        <BrowserRouter>
            <App />
        </BrowserRouter>
    )
}

bootstrap()
